import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { monthYear, shortDateYY } from "LIB/formatters/date";
import { getFirstNameLastInitial, truncate } from "LIB/formatters/text";
import { dollars } from "LIB/formatters/currency";
import {
  INCOMING_LINE_ITEMS,
  NO_QUOTE
} from "MODULES/IncomingQuotes/constants";
import LineItemStatusCell from "MODULES/shared/components/LineItemStatusCell";
import { NoteTooltipTableCell } from "MODULES/shared/components/NoteTooltip";
import {
  DataTable,
  SearchPropTypes,
  CompanyName
} from "MODULES/shared/components";
import ModifiedFlag from "MODULES/parts/components/ModifiedFlag";
import { IncidentRelatedFlag } from "MODULES/IncomingQuotes/shared/IncidentRelatedFlag";
import { AsIsFlag } from "MODULES/IncomingQuotes/shared/AsIsFlag";
import LineItemQtyCell from "MODULES/shared/components/LineItemQtyCell/LineItemQtyCell";
import _ from "lodash";

function renderRow(lineItem, i, pushHistory) {
  const handleMailto = e => {
    e.stopPropagation();
  };

  return (
    <tr
      key={lineItem.id}
      className="clickable"
      onClick={() => pushHistory(`/incoming-quotes/${lineItem.quote_id}`)}
    >
      <td>
        <div style={{ whiteSpace: "nowrap" }}>
          <div style={{ textAlign: "right" }}>
            <LineItemQtyCell lineItem={lineItem} showFull type="IQ" />
            {i + 1}
          </div>
        </div>
      </td>
      <LineItemStatusCell lineItem={lineItem}>
        {lineItem.quote_code}
      </LineItemStatusCell>
      <td>
        <span className={lineItem.updated_tracked_fields_at && "text-yellow"}>
          {shortDateYY(
            lineItem.updated_tracked_fields_at || lineItem.created_at
          )}
        </span>
      </td>
      <td>
        {truncate(
          getFirstNameLastInitial(_.get(lineItem, "buyer.full_name")),
          14
        )}
      </td>
      <td>{INCOMING_LINE_ITEMS.quoteType[lineItem.quote_type].abbrev}</td>
      <td>
        <CompanyName
          company={{
            id: lineItem.company_id,
            name: lineItem.company_name || lineItem.legacy_company_name,
            company_type: lineItem.company_company_type
          }}
          truncateAt={25}
        />
      </td>
      <td>{lineItem.expected_serial_number}</td>
      <td>{lineItem.contact_name}</td>
      <td>
        <a href={`mailto:${lineItem.contact_email}`} onClick={handleMailto}>
          {truncate(lineItem.contact_email, 15)}
        </a>
      </td>
      <td className="text-center">
        {lineItem.trace_type &&
          INCOMING_LINE_ITEMS.traceTypes[lineItem.trace_type].abbrev}
      </td>
      <td className="text-center">
        {lineItem.tag_date && monthYear(lineItem.tag_date)}
      </td>
      <td className="text-center">{truncate(lineItem.tagged_by, 15)}</td>
      <td>{lineItem.modified && <ModifiedFlag />}</td>
      <td>
        {lineItem.condition &&
          lineItem.quote_type !== NO_QUOTE &&
          INCOMING_LINE_ITEMS.condition[lineItem.condition].abbrev}
        <IncidentRelatedFlag lineItem={lineItem} />
        <AsIsFlag lineItem={lineItem} className="m-l-5" />
      </td>
      <td className="text-center">{lineItem.quantity}</td>
      <td className="text-center">{truncate(lineItem.lead_time)}</td>
      <td className="text-right">
        {lineItem.exchange_fee &&
          lineItem.exchange_fee > 0 &&
          dollars(lineItem.exchange_fee)}
      </td>
      <td className="text-right">
        {lineItem.cost && lineItem.cost > 0 && dollars(lineItem.cost)}
      </td>
      <td className="text-right">{truncate(lineItem.warranty, 15)}</td>
      <NoteTooltipTableCell note={lineItem.notes} />
    </tr>
  );
}

export function Table(props) {
  const { pushHistory, isLoading, results } = props;

  return (
    <DataTable loading={isLoading} numbered>
      <DataTable.Head>
        <th />
        <th>Quote #</th>
        <th>Date</th>
        <th>Buyer</th>
        <th>Type</th>
        <th>Vendor</th>
        <th>Serial #</th>
        <th>Contact</th>
        <th>Email</th>
        <th className="text-center">Trace</th>
        <th className="text-center">Tag Date</th>
        <th className="text-center">Tagged By</th>
        <th />
        <th>Cond</th>
        <th className="text-center">QTY</th>
        <th className="text-center">LT</th>
        <th className="text-right">Exch</th>
        <th className="text-right">Cost per Unit</th>
        <th className="text-right">Warranty</th>
        <th />
      </DataTable.Head>
      <DataTable.Body>
        {results.map((r, i) => renderRow(r, i, pushHistory))}
      </DataTable.Body>
    </DataTable>
  );
}

Table.propTypes = {
  pushHistory: PropTypes.func.isRequired,
  ...SearchPropTypes
};

export default connect(undefined, { pushHistory: push })(Table);



// WEBPACK FOOTER //
// ./app/modules/parts/components/IncomingQuoteLineItems/Table.jsx